export default "__VITE_PUBLIC_ASSET__961edb13__"